import { push, ref, update } from "firebase/database";
import { database } from "../../../Utils/firebase";
import GetExpenseDataFirebase from "./GetExpenseDataFirebase";

const EditExpenseDataInFirebae = async (state, dispatch, id, expenseData, userId) => {

    const USERID = userId ? userId : state?.USERID

    console.log("userid", USERID);

    if (!USERID) return null;

    try {



        // Reference to user's invoice data
        const userRef = ref(database, `invoiceGenerator/users/${USERID}/expense/${id}`);

        // Push new invoice data
        const actorName = state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest";

        // Update expense data
        await update(userRef, {
            updatedBy: actorName,
            companyId: expenseData?.companyId?.toString() || "",
            createdDate: new Date().getTime().toString(),
            amount: expenseData?.amount?.toString() || "",
            expenseCategory: (expenseData?.category || expenseData?.expenseCategory)?.toString() || "",
            expenseDate: expenseData?.expenseDate || new Date().toISOString().slice(0, 10), // Defaults to today
            expenseDescription: (expenseData?.description || expenseData?.expenseDescription)?.toString() || "",
            expenseId: expenseData?.expenseId?.toString() || "",
            paymentMethod: expenseData?.paymentMethod || "Cash",
            expenseName: expenseData?.expenseName || "",
            updateDate: expenseData?.updateDate?.toString() || new Date().getTime().toString(),
            platform: "website",
            version: process.env.REACT_APP_VERSION,
            currency: expenseData?.currency?.toString() || "",
        });

        // Fetch updated invoice data
        await GetExpenseDataFirebase(state, dispatch);

        return { success: true, message: "Expense updated successfully!" };
    } catch (error) {
        return { success: false, message: error };
    }
};

export default EditExpenseDataInFirebae;
